const navigationBlocks = document.querySelectorAll('.block-navigation');
const clientLoginsBlocks = document.querySelectorAll(
	'.block-navigation-client-logins'
);

const openEvent = new Event('navigation-client-logins-opened');
const closeEvent = new Event('navigation-client-logins-closed');

const clientLoginsButtons = document.querySelectorAll(
	'.block-navigation-client-logins__button'
);

const toggleClientLogins = (e) => {
	const currentButton = e.currentTarget;
	const currentNavigationBlock = currentButton.closest('.block-navigation');

	if (!currentNavigationBlock) {
		return;
	}

	currentNavigationBlock.classList.toggle('client-logins-active');

	if (currentNavigationBlock.classList.contains('client-logins-active')) {
		navigationBlocks.forEach((navigationBlock) => {
			if (navigationBlock === currentNavigationBlock) {
				return;
			}

			navigationBlock.classList.remove('client-logins-active');

			const openElements = navigationBlock.querySelectorAll(
				'[aria-expanded="true"]'
			);

			if (openElements.length > 0) {
				openElements.forEach((openElement) => {
					openElement.setAttribute('aria-expanded', false);
				});
			}
		});

		currentButton.setAttribute('aria-expanded', true);
	} else {
		currentButton.setAttribute('aria-expanded', false);
	}

	if (currentNavigationBlock.classList.contains('client-logins-active')) {
		window.dispatchEvent(openEvent);

		document.addEventListener('keydown', clickOffMenu);
		document.addEventListener('click', clickOffMenu);
	} else {
		window.dispatchEvent(closeEvent);

		document.removeEventListener('keydown', clickOffMenu);
		document.removeEventListener('click', clickOffMenu);
	}
};

const closeClientLogins = () => {
	if (0 === clientLoginsBlocks.length || 0 === navigationBlocks.length) {
		return;
	}

	navigationBlocks.forEach((navigationBlock) => {
		navigationBlock.classList.remove('client-logins-active');
	});

	clientLoginsButtons.forEach((button) => {
		button.setAttribute('aria-expanded', false);
	});

	window.dispatchEvent(closeEvent);

	document.removeEventListener('keydown', clickOffMenu);
	document.removeEventListener('click', clickOffMenu);
};

const clickOffMenu = (e) => {
	if (0 === navigationBlocks.length) {
		return;
	}

	let closestDropdown;
	let closestButton;

	if (e.key === undefined && e.target) {
		closestDropdown = e.target.closest(
			'.block-navigation-client-logins__dropdown'
		);
		closestButton = e.target.closest(
			'.block-navigation-client-logins__button'
		);
	}

	if (e.key && e.key !== 'Escape') {
		return;
	}

	if (
		closestDropdown?.contains(e.target) ||
		closestButton?.contains(e.target)
	) {
		return;
	}

	navigationBlocks.forEach((navigationBlock) => {
		if (navigationBlock.classList.contains('client-logins-active')) {
			navigationBlock.classList.remove('client-logins-active');

			document.removeEventListener('keydown', clickOffMenu);
			document.removeEventListener('click', clickOffMenu);

			const openButtons = navigationBlock.querySelectorAll(
				'.block-navigation-client-logins__button[aria-expanded="true"]'
			);

			if (openButtons.length > 0) {
				openButtons.forEach((button) => {
					button.setAttribute('aria-expanded', false);
				});
			}
		}
	});

	window.dispatchEvent(closeEvent);
};

if (clientLoginsButtons.length > 0) {
	clientLoginsButtons.forEach((button) => {
		button.addEventListener('click', toggleClientLogins);
	});
}

window.addEventListener('navigation-opened', closeClientLogins);
window.addEventListener('navigation-submenu-opened', closeClientLogins);
window.addEventListener('navigation-search-opened', closeClientLogins);
